import { createItemStorage } from "../../utils/createItemStorage";

export const apiMock = ({ storage }) => createItemStorage(storage, "x-api-mock");
